import { render, staticRenderFns } from "./FileMultipleIcon.vue?vue&type=template&id=6e2ba7a7"
import script from "./FileMultipleIcon.vue?vue&type=script&lang=js"
export * from "./FileMultipleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports